import { Component } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidUpdate(prev) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="m-4 p-5 bg-rose-50 border-2 border-rose-300 rounded-lg" data-testid="page-error">
        <div className="flex items-center gap-2 text-rose-800 font-extrabold"><AlertTriangle className="w-5 h-5" />HALAMAN GAGAL DITAMPILKAN</div>
        <p className="text-sm text-rose-700 mt-1 no-up">Terjadi kesalahan saat menampilkan halaman ini. Data Anda aman — ini hanya masalah tampilan. Silakan muat ulang; bila terus terjadi, kirim pesan di bawah ke pengembang.</p>
        <pre className="mt-2 text-xs bg-white border border-rose-200 rounded p-2 overflow-auto max-h-40 no-up" data-testid="page-error-detail">{String(this.state.error?.message || this.state.error)}</pre>
        <button onClick={() => window.location.reload()} className="mt-3 inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-slate-900 text-white text-sm font-semibold" data-testid="page-error-reload"><RefreshCw className="w-4 h-4" />Muat Ulang</button>
      </div>
    );
  }
}
